"use client";

import { AuthLayout } from "@/components/catalyst/auth-layout";
import { Button } from "@/components/catalyst/button";
import NextError from "next/error";
import { useEffect } from "react";
import posthog from "posthog-js";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <AuthLayout>
          {/* `NextError` is the default Next.js error page component */}
          <NextError statusCode={0} />
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button color="purple" onClick={() => reset()}>
              Try again
            </Button>
          </div>
        </AuthLayout>
      </body>
    </html>
  );
}
